import React, {useContext, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {validateEmail} from "../../../utils/validateEmail";
import {useAuthorization} from "../api/useAuthorization";
import LockedError from "../components/LockedError";
import LoginForm from "../components/LoginForm";
import LoginSessionPanel from "../components/LoginSessionPanel/LoginSessionPanel";
import UserImportError from "../components/UserImportError";
import {BasePathUrl} from "../../../appsettings";
import {EsiaLoginButtons} from "../components/EsiaLoginButtons";
import s from "../styles/login.module.css";
import {getModules} from "../../../pages/modules-list/ModulesList";
import UISettingsContext from "../../../utils/UISettingsContext";
import {Footer} from "../components/Footer";
import {parseReturnUrl} from "../../../utils/returnUrl";
import {State} from "../../../redux/store";

export const Login = () => {
  const {error, loading, signIn, clearError, user} = useAuthorization();
  const isAuth = useSelector((state: State) => state.auth.data.isAuth);
  const hasSessionWithoutModuleAccess = !isAuth && Boolean(user?.id);
  const returnUrl = parseReturnUrl();
  const [isEsiaEnabled, setEsiaEnabled] = useState<boolean>();
  const [showRegistrationBtn, setShowRegistrationBtn] = useState(false);
  const {name, logo} = useContext(UISettingsContext);

  useEffect(() => {
    const inner = async () => {
      try {
        const externalModules = await getModules();
        if(externalModules.length > 0) {
          setShowRegistrationBtn(true);
        };
      } catch (e) {
        console.error(e);
      }
    };

    inner();
  }, []);

  const onSignIn = ({login, password}: {login: string, password: string}) => {
    if (validateEmail(login)) {
      signIn({
        email: login,
        password: password,
        returnUrl: returnUrl ? returnUrl : "/"
      });
    } else {
      signIn({
        username: login,
        password: password,
        returnUrl: returnUrl ? returnUrl : "/"
      });
    }
  };

  const getConfiguration = async () => {
    const res = await fetch(`${BasePathUrl}/api/ext-auth/config`);
    const config = await res.json();
    return config;
  };

  const initialize = async () => {
      const config = await getConfiguration();

      setEsiaEnabled(config.esiaEnabled);
  };

  useEffect(() => {
      initialize();
  }, []);

  return (
    <div className={s.container}>
      <div className={s.login}>

        <div className={s.login__header}>
          <img
            src={logo}
            alt="P4m"
            className={s.login__header__logo}
          />
          <span className={s.login__header__title}>{name || ""}</span>
        </div>

        {hasSessionWithoutModuleAccess ? (
          <LoginSessionPanel />
        ) : (
          <>
            {(!error || error.code !== "LOCKED" && error.code !== "USER_IMPORT_ERR") && (
              <LoginForm
                showRegistrationBtn={showRegistrationBtn}
                loading={loading.signIn}
                error={error}
                clearError={clearError}
                onSignIn={onSignIn}
                extra={!isEsiaEnabled ? undefined : <EsiaLoginButtons />}
              />
            )}
            {error?.code === "LOCKED" && (
              <LockedError error={error} />
            )}
            {error?.code === "USER_IMPORT_ERR" && (
              <UserImportError error={error} />
            )}
          </>
        )}

      </div>

      <Footer />
    </div>
  );
};
